import { useLocation, useParams } from 'react-router-dom';
import queryString from 'query-string';

export function useLocationHook() {
    const { pathname, search } = useLocation();

    const { slug }: { slug: string } = useParams();
    const { url } = queryString.parseUrl(slug);

    const log = queryString.parseUrl(pathname);
    const logSearch = queryString.parse(search);

    const statePopular = !log.query.popular
        ? logSearch.popular
        : log.query.popular;
    return { url, statePopular };
}
